import common from "@/mixins/common";

export const mixins = {
  mixins: [common],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},
  methods: {},
};
